var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as Enumerable from "linq";
import { autoinject } from "aurelia-dependency-injection";
import { noView } from "aurelia-templating";
import { customAttribute } from "aurelia-templating";
import { bindable } from "aurelia-templating";
import { ValidationsClientService } from "../../../../services/validations/validations-client.service";
import { EventAggregator } from "aurelia-event-aggregator";
import { Messages } from "../../../../configuration/event-messages.constants";
import { Guid } from "../../../../utilities/guid";
import { ValidationTypeEnum } from "../../../../client-validation-system/validations.models";
var ValidationPropertyCustomAttribute = /** @class */ (function () {
    function ValidationPropertyCustomAttribute(element, validationService, eventAggregator) {
        this.element = element;
        this.validationService = validationService;
        this.eventAggregator = eventAggregator;
        // this will turn red those inputs which have an error
        this.eventAggregator.subscribe(Messages.onValidated, this.onValidated.bind(this));
    }
    ValidationPropertyCustomAttribute.prototype.propertyNameChanged = function (newValue, oldValue) {
        this.invalidate();
    };
    ValidationPropertyCustomAttribute.prototype.entityTypeChanged = function (newValue, oldValue) {
        this.invalidate();
    };
    ValidationPropertyCustomAttribute.prototype.onValidated = function (validationResult) {
        var _this = this;
        if (validationResult) {
            var validationError = Enumerable.from(validationResult.errors).firstOrDefault(function (x) { return x.identifier === _this.identifier &&
                x.propertyName.toLowerCase() === _this.propertyName.toLowerCase(); });
            if (validationError) {
                if (validationResult.hasError && $(this.element).find("input").attr("disabled") != "disabled") {
                    this.element.classList.add("error-validation");
                }
                else {
                    this.element.classList.remove("error-validation");
                }
            }
            else {
                this.element.classList.remove("error-validation");
            }
        }
    };
    ValidationPropertyCustomAttribute.prototype.invalidate = function () {
        var _this = this;
        if (this.propertyName && this.entityType) {
            this.validationService.getValidationRules(this.entityType)
                .then(function (res) {
                if (_this.isRequired(_this.propertyName, res)) {
                    _this.element.classList.add("required");
                }
            });
        }
    };
    ValidationPropertyCustomAttribute.prototype.isRequired = function (propertyName, validationRules) {
        if (validationRules) {
            var isRequired = Enumerable.from(validationRules).any(function (rule) { return (propertyName &&
                (rule.tableColumnMetadata &&
                    rule.tableColumnMetadata.columnName &&
                    rule.tableColumnMetadata.columnName.toLowerCase() === propertyName.toLowerCase()) ||
                // also check for collection validations 
                (rule.entityTypeRelation &&
                    rule.entityTypeRelation.relationName &&
                    rule.entityTypeRelation.relationName.toLowerCase() === propertyName.toLowerCase())) &&
                rule.validationType === ValidationTypeEnum.Required; });
            return isRequired;
        }
        return false;
    };
    __decorate([
        bindable,
        __metadata("design:type", Guid)
    ], ValidationPropertyCustomAttribute.prototype, "identifier", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], ValidationPropertyCustomAttribute.prototype, "entityType", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], ValidationPropertyCustomAttribute.prototype, "propertyName", void 0);
    ValidationPropertyCustomAttribute = __decorate([
        customAttribute("validation-property"),
        noView,
        autoinject,
        __metadata("design:paramtypes", [Element,
            ValidationsClientService,
            EventAggregator])
    ], ValidationPropertyCustomAttribute);
    return ValidationPropertyCustomAttribute;
}());
export { ValidationPropertyCustomAttribute };
